/**
 * components/layout/TenantMark.tsx
 *
 * The deployment tenant's mark: its logo file
 * (public/tenant-assets/<iata>/logo.svg), or its IATA code when that file
 * is missing. Renders nothing without branding -- never a placeholder
 * airline.
 */
import { useState } from 'react';
import { brandingLogoPath, useBranding } from '@/lib/branding';
import { cn } from '@/lib/utils/cn';

export interface TenantMarkProps {
  className?: string;
}

export function TenantMark({ className }: TenantMarkProps) {
  const branding = useBranding();
  const [logoFailed, setLogoFailed] = useState(false);
  if (!branding) return null;

  if (!logoFailed) {
    return (
      <img
        src={brandingLogoPath(branding)}
        alt={branding.brand_name}
        onError={() => setLogoFailed(true)}
        className={cn('h-8 w-8 rounded-sm object-contain', className)}
      />
    );
  }
  return (
    <div
      className={cn(
        'flex h-8 w-8 items-center justify-center rounded-sm bg-qr-maroon text-[11px] font-semibold tracking-[0.18em] text-white',
        className,
      )}
      aria-label={branding.brand_name}
    >
      {branding.iata_code}
    </div>
  );
}
